module.exports = __webpack_public_path__ + "img/3d-glasses-2.0a39a78b.png";